import React, { useRef, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import { TextField, Box, InputAdornment } from "@mui/material";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";

const containerStyle = {
  width: "100%",
  height: "300px",
};

function MapaDireccionEnv(props) {
  const inputRef = useRef();
  const searchBoxRef = useRef();

  const center = {
    lat: parseFloat(props.datosDir.latitud) || -32.9468, // Rosario por defecto
    lng: parseFloat(props.datosDir.longitud) || -60.6393,
  };

  const handlePlaceChange = () => {
    const places = searchBoxRef.current.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      props.setDatosDir({
        ...props.datosDir,
        direccion_entrega: place.formatted_address,
        latitud: place.geometry.location.lat(),
        longitud: place.geometry.location.lng(),
      });
    }
  };

  const googleMapsApiKey = process.env.REACT_APP_Google_maps_key;

  // 🔥 Inyecta estilo para asegurar que el dropdown del autocompletado se vea
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      .pac-container {
        z-index: 99999 !important;
        position: absolute !important;
      }
    `;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  return (
    <Box width="100%">
      <LoadScript googleMapsApiKey={googleMapsApiKey} libraries={["places"]}>
        <StandaloneSearchBox
          onLoad={(ref) => (searchBoxRef.current = ref)}
          onPlacesChanged={handlePlaceChange}
        >
          <Box mb={1} mt={1} sx={{ position: "relative", zIndex: 2000 }}>
            <TextField
              inputRef={inputRef}
              label="Buscar Dirección.."
              fullWidth
              placeholder="Dirección"
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TravelExploreIcon color="primary" />
                  </InputAdornment>
                ),
              }}
              focused
            />
          </Box>
        </StandaloneSearchBox>

        <Box sx={{ position: "relative" }}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
          >
            <Marker
              position={center}
              draggable={true}
              onDragEnd={(p) =>
                props.setDatosDir({
                  ...props.datosDir,
                  latitud: p.latLng.lat(),
                  longitud: p.latLng.lng(),
                })
              }
            />
          </GoogleMap>
        </Box>
      </LoadScript>
    </Box>
  );
}

export default MapaDireccionEnv;
